// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as SelectedRouteImport } from './routes/selected'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as FuerVisagistenRouteImport } from './routes/fuer-visagisten'
import { Route as FuerFotografenRouteImport } from './routes/fuer-fotografen'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VisagistsIndexRouteImport } from './routes/visagists.index'
import { Route as PhotographersIndexRouteImport } from './routes/photographers.index'
import { Route as MagazinIndexRouteImport } from './routes/magazin.index'
import { Route as VisagistsIdRouteImport } from './routes/visagists.$id'
import { Route as VisagistCityRouteImport } from './routes/visagist.$city'
import { Route as ThemesThemeRouteImport } from './routes/themes.$theme'
import { Route as PhotographersIdRouteImport } from './routes/photographers.$id'
import { Route as MagazinWieVielKostetEinFotografRouteImport } from './routes/magazin.wie-viel-kostet-ein-fotograf'
import { Route as MagazinTippsAmateurModelsRouteImport } from './routes/magazin.tipps-amateur-models'
import { Route as MagazinRedFlagFragenRouteImport } from './routes/magazin.red-flag-fragen'
import { Route as MagazinTopicRouteImport } from './routes/magazin.$topic'
import { Route as FotografCityRouteImport } from './routes/fotograf.$city'
import { Route as AccountVisagistRouteImport } from './routes/account.visagist'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as SelectedArchiveRouteImport } from './routes/selected.archive'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminVisagistsRouteImport } from './routes/admin.visagists'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSelectedRouteImport } from './routes/admin.selected'
import { Route as AdminRolesRouteImport } from './routes/admin.roles'
import { Route as AdminPhotographersRouteImport } from './routes/admin.photographers'
import { Route as AdminPhotoOfTheDayRouteImport } from './routes/admin.photo-of-the-day'
import { Route as AdminOgPreviewRouteImport } from './routes/admin.og-preview'
import { Route as AdminCommunityRouteImport } from './routes/admin.community'
import { Route as AdminBriefsRouteImport } from './routes/admin.briefs'
import { Route as AdminApplicationsRouteImport } from './routes/admin.applications'
import { Route as VisagistsThemesThemeRouteImport } from './routes/visagists.themes.$theme'
import { Route as VisagistCityThemeRouteImport } from './routes/visagist.$city.$theme'
import { Route as FotografCityThemeRouteImport } from './routes/fotograf.$city.$theme'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const SelectedRoute = SelectedRouteImport.update({
            id: '/selected',path: '/selected',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const FuerVisagistenRoute = FuerVisagistenRouteImport.update({
            id: '/fuer-visagisten',path: '/fuer-visagisten',getParentRoute: () => rootRouteImport
          })
const FuerFotografenRoute = FuerFotografenRouteImport.update({
            id: '/fuer-fotografen',path: '/fuer-fotografen',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const BriefRoute = BriefRouteImport.update({
            id: '/brief',path: '/brief',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const VisagistsIndexRoute = VisagistsIndexRouteImport.update({
            id: '/visagists/',path: '/visagists/',getParentRoute: () => rootRouteImport
          })
const PhotographersIndexRoute = PhotographersIndexRouteImport.update({
            id: '/photographers/',path: '/photographers/',getParentRoute: () => rootRouteImport
          })
const MagazinIndexRoute = MagazinIndexRouteImport.update({
            id: '/magazin/',path: '/magazin/',getParentRoute: () => rootRouteImport
          })
const VisagistsIdRoute = VisagistsIdRouteImport.update({
            id: '/visagists/$id',path: '/visagists/$id',getParentRoute: () => rootRouteImport
          })
const VisagistCityRoute = VisagistCityRouteImport.update({
            id: '/visagist/$city',path: '/visagist/$city',getParentRoute: () => rootRouteImport
          })
const ThemesThemeRoute = ThemesThemeRouteImport.update({
            id: '/themes/$theme',path: '/themes/$theme',getParentRoute: () => rootRouteImport
          })
const PhotographersIdRoute = PhotographersIdRouteImport.update({
            id: '/photographers/$id',path: '/photographers/$id',getParentRoute: () => rootRouteImport
          })
const MagazinWieVielKostetEinFotografRoute = MagazinWieVielKostetEinFotografRouteImport.update({
            id: '/magazin/wie-viel-kostet-ein-fotograf',path: '/magazin/wie-viel-kostet-ein-fotograf',getParentRoute: () => rootRouteImport
          })
const MagazinTippsAmateurModelsRoute = MagazinTippsAmateurModelsRouteImport.update({
            id: '/magazin/tipps-amateur-models',path: '/magazin/tipps-amateur-models',getParentRoute: () => rootRouteImport
          })
const MagazinRedFlagFragenRoute = MagazinRedFlagFragenRouteImport.update({
            id: '/magazin/red-flag-fragen',path: '/magazin/red-flag-fragen',getParentRoute: () => rootRouteImport
          })
const MagazinTopicRoute = MagazinTopicRouteImport.update({
            id: '/magazin/$topic',path: '/magazin/$topic',getParentRoute: () => rootRouteImport
          })
const FotografCityRoute = FotografCityRouteImport.update({
            id: '/fotograf/$city',path: '/fotograf/$city',getParentRoute: () => rootRouteImport
          })
const AccountVisagistRoute = AccountVisagistRouteImport.update({
            id: '/account/visagist',path: '/account/visagist',getParentRoute: () => rootRouteImport
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/account/profile',path: '/account/profile',getParentRoute: () => rootRouteImport
          })
const SelectedArchiveRoute = SelectedArchiveRouteImport.update({
            id: '/archive',path: '/archive',getParentRoute: () => SelectedRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminVisagistsRoute = AdminVisagistsRouteImport.update({
            id: '/visagists',path: '/visagists',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminSelectedRoute = AdminSelectedRouteImport.update({
            id: '/selected',path: '/selected',getParentRoute: () => AdminRoute
          })
const AdminRolesRoute = AdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AdminRoute
          })
const AdminPhotographersRoute = AdminPhotographersRouteImport.update({
            id: '/photographers',path: '/photographers',getParentRoute: () => AdminRoute
          })
const AdminPhotoOfTheDayRoute = AdminPhotoOfTheDayRouteImport.update({
            id: '/photo-of-the-day',path: '/photo-of-the-day',getParentRoute: () => AdminRoute
          })
const AdminOgPreviewRoute = AdminOgPreviewRouteImport.update({
            id: '/og-preview',path: '/og-preview',getParentRoute: () => AdminRoute
          })
const AdminCommunityRoute = AdminCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => AdminRoute
          })
const AdminBriefsRoute = AdminBriefsRouteImport.update({
            id: '/briefs',path: '/briefs',getParentRoute: () => AdminRoute
          })
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AdminRoute
          })
const VisagistsThemesThemeRoute = VisagistsThemesThemeRouteImport.update({
            id: '/visagists/themes/$theme',path: '/visagists/themes/$theme',getParentRoute: () => rootRouteImport
          })
const VisagistCityThemeRoute = VisagistCityThemeRouteImport.update({
            id: '/$theme',path: '/$theme',getParentRoute: () => VisagistCityRoute
          })
const FotografCityThemeRoute = FotografCityThemeRouteImport.update({
            id: '/$theme',path: '/$theme',getParentRoute: () => FotografCityRoute
          })





const AdminRouteChildren = {
  AdminApplicationsRoute: AdminApplicationsRoute,AdminBriefsRoute: AdminBriefsRoute,AdminCommunityRoute: AdminCommunityRoute,AdminOgPreviewRoute: AdminOgPreviewRoute,AdminPhotoOfTheDayRoute: AdminPhotoOfTheDayRoute,AdminPhotographersRoute: AdminPhotographersRoute,AdminRolesRoute: AdminRolesRoute,AdminSelectedRoute: AdminSelectedRoute,AdminSettingsRoute: AdminSettingsRoute,AdminVisagistsRoute: AdminVisagistsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const SelectedRouteChildren = {
  SelectedArchiveRoute: SelectedArchiveRoute
}

const SelectedRouteWithChildren = SelectedRoute._addFileChildren(SelectedRouteChildren)




const FotografCityRouteChildren = {
  FotografCityThemeRoute: FotografCityThemeRoute
}

const FotografCityRouteWithChildren = FotografCityRoute._addFileChildren(FotografCityRouteChildren)




const VisagistCityRouteChildren = {
  VisagistCityThemeRoute: VisagistCityThemeRoute
}

const VisagistCityRouteWithChildren = VisagistCityRoute._addFileChildren(VisagistCityRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,ApplyRoute: ApplyRoute,BriefRoute: BriefRoute,CookiesRoute: CookiesRoute,DatenschutzRoute: DatenschutzRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,FuerFotografenRoute: FuerFotografenRoute,FuerVisagistenRoute: FuerVisagistenRoute,ImpressumRoute: ImpressumRoute,LoginRoute: LoginRoute,ResetPasswordRoute: ResetPasswordRoute,SelectedRoute: SelectedRouteWithChildren,UnsubscribeRoute: UnsubscribeRoute,AccountProfileRoute: AccountProfileRoute,AccountVisagistRoute: AccountVisagistRoute,FotografCityRoute: FotografCityRouteWithChildren,MagazinTopicRoute: MagazinTopicRoute,MagazinRedFlagFragenRoute: MagazinRedFlagFragenRoute,MagazinTippsAmateurModelsRoute: MagazinTippsAmateurModelsRoute,MagazinWieVielKostetEinFotografRoute: MagazinWieVielKostetEinFotografRoute,PhotographersIdRoute: PhotographersIdRoute,ThemesThemeRoute: ThemesThemeRoute,VisagistCityRoute: VisagistCityRouteWithChildren,VisagistsIdRoute: VisagistsIdRoute,MagazinIndexRoute: MagazinIndexRoute,PhotographersIndexRoute: PhotographersIndexRoute,VisagistsIndexRoute: VisagistsIndexRoute,VisagistsThemesThemeRoute: VisagistsThemesThemeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)